import riskDescription from './riskDescription';
export default (concept, description, color, reasons) => `<div class="risk-box">
${riskDescription(concept, description, reasons)}
<div class="risk-circle-box">
  <svg height="40" width="40" class="risk-svg">
    <circle cx="20" cy="20" r="15" class=${color} />
  </svg>
</div>
</div>`;
